import InsButton from "components/InsButton/InsButton";
import InsCheckbox from "components/InsCheckbox/InsCheckbox";
import React, { useState } from "react";
import "./NewsletterCampaign.css";
import { updateNewsletterCampaignConsent } from "api/newsletter";

const Label = ({ description, link, linkTitle }) => {
  return (
    <p>
      {description} <a href={link}>{linkTitle}</a>
    </p>
  );
};

const NewsletterCampaign = ({
  id,
  title,
  description,
  acceptLabel,
  refusalLabel,
  link,
  linkTitle,
  close,
}) => {
  const [read, setread] = useState(false);
  const handleAccept = async () => {
    await updateNewsletterCampaignConsent(id, true);
    close();
  };

  const handleRefusal = async () => {
    await updateNewsletterCampaignConsent(id, false);
    close();
  };

  return (
    <div className="newsletter-campaign">
      <span className="campaign-title">{title}</span>
      <InsCheckbox
        label={
          <Label description={description} link={link} linkTitle={linkTitle} />
        }
        name="consent"
        checked={read}
        onClick={(e) => setread(e.target.checked)}
      />
      <div className="buttons">
        <InsButton
          type="white"
          text={acceptLabel}
          onClick={handleAccept}
          disabled={!read}
        />
        <button onClick={handleRefusal} className="refusal-btn">{refusalLabel}</button>
      </div>
    </div>
  );
};

export default NewsletterCampaign;
